import imageSource from '../../assets/AngularJS.png';

export default function OAuth2AuthorizationProxyDemoAppHomePageComponentController() {
    this.imageSource = imageSource;
};
